import NetworkCall from "network/networkCall";
import Request from "network/request";

export default class Export {
  static async getReportJobsVacancies(params, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.exportReportJobsVacancies(params),
      useLoading,
    );
  }

  static async getReportCandidateJobEntries(params, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.exportReportCandidateJobEntries(params),
      useLoading,
    );
  }

  static async getReportEngagements(params) {
    return NetworkCall.fetch(Request.v2.exportEngagements(params));
  }

  static async getReportJobBillings(clientId, params) {
    return NetworkCall.fetch(Request.v2.exportJobBillings(clientId, params));
  }

  static async getReportInvoiceDetail(invoiceId) {
    return NetworkCall.fetch(Request.v2.exportJobInvoice(invoiceId));
  }

  static async getReportCommissionStatements(params) {
    return NetworkCall.fetch(
      Request.v2.exportCommissionStatements(params),
      false,
    );
  }

  static async getReportCommissionApprovals(params) {
    return NetworkCall.fetch(
      Request.v2.exportCommissionApprovals(params),
      false,
    );
  }

  static async getReportCommissionApprovalsSummary(params) {
    return NetworkCall.fetch(
      Request.v2.exportCommissionApprovalsSummary(params),
      false,
    );
  }

  static async getReportInvoices(params) {
    return NetworkCall.fetch(Request.v2.exportInvoices(params));
  }

  static async getReportScheduledJobBills(params) {
    return NetworkCall.fetch(Request.v2.exportScheduledJobBills(params));
  }

  static async getReportClientContacts(params) {
    return NetworkCall.fetch(Request.v2.exportClientContacts(params));
  }

  static async getReportUsers(params) {
    return NetworkCall.fetch(Request.v2.exportUsers(params));
  }
}
